export const formatDate = (date: Date) => {
  let text = new Date(date).toLocaleDateString("sv-SE", {
    dateStyle: "short",
    timeStyle: "short",
  });
  return text.at(0)?.toUpperCase() + text.slice(1);
};

export const formatLongDate = (date: Date) => {
  let text = new Date(date).toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric",
    weekday: "long",
  });
  return text.at(0)?.toUpperCase() + text.slice(1);
};
